<template>
    <div class="tooltipElement tooltipRight">
        <div
            class="qrCode editor_panel-nav-item"
            @click="addElement()"
            :style="colors"
        >
            <inline-svg
                alt="Qr Code"
                :src="add_qrcode_icon"
                fill="#737373"
            />
            <span>{{ $t('editorTabQrTitle') }}</span>
        </div>
        <Tooltip :tooltipText="`${$t('editorTabQrTitle')}`" />
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { uuid } from 'vue-uuid';
    import add_qrcode_icon from '@/assets/icons/panel_icons/qr_icon.svg';
    import Tooltip from '@/components/Global/Tooltip.vue';

    export default {
        data() {
            return {
                add_qrcode_icon
            }
        },
        methods: {
            addElement() {
                let newQrElement = {
                    id: uuid.v1(),
                    pageId: this.getActivePageId,
                    type: 'QR_CODE_ELEMENT',
                    height: 150,
                    width: 150,
                    frame: {
                        translate: [0, 0],
                        scale: [1, 1],
                        rotate: 0
                    },
                    webSizeMM: {
                        width: 150 * 0.084667,
                        height: 150 * 0.084667,
                        translate: [0 * 0.084667, 0 * 0.084667]
                    },
                    isActive: true,
                    frontColor: {
                        rgb: 'rgb(0, 0, 0)',
                        hex: '000000',
                        X: 0,
                        Y: 0
                    },
                    backColor: {
                        rgb: 'rgb(255, 255, 255)',
                        hex: 'FFFFFF',
                        X: 0,
                        Y: 150
                    },
                    placeholder: {
                        hasPlaceholder: false,
                        placeholderId: 'noPlaceholder',
                        placeholderSystemName: 'noPlaceholder'
                    },
                    content: this.$i18n.t('editorTabQrNewItemContent'),
                    zIndex: this.getZIndex,
                    isLocked: false,
                    newTransforms: true
                }

                if (this.getSessionDetails.mode === 'user') {
                    if (this.getActivePage.content.isLocked === false) {
                        this.$store.dispatch('ADD_PAGE_ELEMENT', newQrElement);
                    }
                } else {
                    this.$store.dispatch('ADD_PAGE_ELEMENT', newQrElement);
                }
            }
        },
        computed: {
            ...mapGetters([
                'getZIndex',
                'getActivePageId',
                'getActivePage',
                'getSessionDetails'
            ]),
            colors() {
                return {
                    '--primary-color': `#${this.getSessionDetails.editorSetup.colors.primaryColor}`
                }
            }
        },
        components: {
            Tooltip
        }
    }
</script>

<style scoped>
    .editor_panel-nav-item:hover {
        color: var(--primary-color);
    }
    .editor_panel-nav-item:hover svg {
        fill: var(--primary-color);
    }
</style>